/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { callIfScrollToBottom } from '../../utils/helpers/scroll'
import { useGridStyle } from '../../utils/styles/grid'
import { useScrollStyle } from '../../utils/styles/scroll'
import { useSizeStyle } from '../../utils/styles/size'

const Scroll = ({ children, onScrollToBottom, ...props }) => {
  const style = css`
    ${useScrollStyle({ scroll: true, ...props })}
    ${useSizeStyle(props)}
    ${useGridStyle(props)}
  `

  return (
    <div className="scroll" css={style} onScroll={callIfScrollToBottom(onScrollToBottom)}>
      {children}
    </div>
  )
}

export default Scroll
